import styled from 'styled-components';
import { fadeIn } from '../../../__core/Themes/Animations';

export const UserProfileContainer = styled.div`
  padding: 2rem 2.5rem;
`;

export const DataForEdit = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  animation: ${fadeIn} 0.5s;

  &:last-of-type {
    margin-bottom: 0.5rem;
  }

  & > div {
    & > div.label {
      color: ${({ theme }) => theme.UI_COLORS.medium_gray};
      font-size: ${({ theme }) => theme.TYPOGRAPHY.label.fontSize};
      font-weight: ${({ theme }) => theme.TYPOGRAPHY.label.fontWeight};
      margin-bottom: 0.5rem;
    }

    & > div.positive {
      color: ${({ theme }) => theme.UI_COLORS.success};
    }

    & > div.value {
      color: ${({ theme }) => theme.UI_COLORS.secondary};
      font-size: ${({ theme }) => theme.TYPOGRAPHY.bodyTextSmall.fontSize};
      font-weight: ${({ theme }) => theme.TYPOGRAPHY.bodyTextSmall.fontWeight};
      margin-bottom: 0.5rem;
    }

    & > div.error {
      color: ${({ theme }) => theme.UI_COLORS.error};
    }
  }

  .icon > svg {
    fill: ${({ theme }) => theme.UI_COLORS.secondary};
    margin-right: 1rem;
  }
`;

export const UserProfileForm = styled.div`
  margin-bottom: 3rem;
  & > .form-group {
    position: relative;
    margin-bottom: 2rem;

    & > span.error {
      color: ${({ theme }) => theme.UI_COLORS.error};
      font-size: ${({ theme }) => theme.FONT_SIZES.small};
      position: absolute;
      left: 0;
      bottom: -13px;
    }
  }

  & > input,
  & > div > input {
    border: 1px solid ${({ theme }) => theme.UI_COLORS.medium_gray};
    box-sizing: border-box;
    border-radius: 6px;
    outline: none;
    width: 100%;
    padding: 1rem;

    &.error {
      border-color: ${({ theme }) => theme.UI_COLORS.error};
    }
  }
`;
